import { useState, useEffect } from "react";
import api from "../api";
const API = process.env.REACT_APP_API_URL;

function AddStudent() {

  const [form, setForm] = useState({
    AdmNo: "",
    Name: "",
    FatherName: "",
    MotherName: "",
    Address: "",
    Class: "One",
    Section: "A",
    AdmissionType: "Old",   // ✅ ADD (default Old)
    Phone: "",
    RouteNo: 0
  });

  const [routes, setRoutes] = useState([]);


  useEffect(() => {
    api.get(`${API}/next-admno`)
      .then(res => {
        setForm(prev => ({
          ...prev,
          AdmNo: res.data.next
        }));
      })
      .catch(err => console.log(err));
  }, []);


  // 🔹 Load routes from DB
  useEffect(() => {
    api.get(`${API}/conveyance`)
      .then(res => setRoutes(res.data))
      .catch(err => console.log(err));
  }, []);

  // 🔹 Handle input change
  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  // 🔹 Save student
  const handleSave = () => {

    if (!form.Name || !form.Class || !form.MotherName || !form.Address || !form.Phone) {
      alert("Please fill required fields");
      return;
    }

    api.post(`${API}/add-student`, form)
      .then(res => {
        if (!res.data.success) {
          throw new Error(res.data.message);
        }

        alert("Student Added. Admission No: " + res.data.AdmNo);

        // 🔹 Reset form (keep AdmNo empty for now)
        setForm({
          AdmNo: "",
          Name: "",
          FatherName: "",
          MotherName: "",
          Address: "",
          Class: "One",
          Section: "A",
          AdmissionType: "Old",
          Phone: "",
          RouteNo: 0
        });

        // 🔥 fetch next admno
        return api.get(`${API}/next-admno`);
      })
      .then(res => {
        setForm(prev => ({
          ...prev,
          AdmNo: res.data.next
        }));
      })
      .catch(err => {
        alert(err.response?.data?.message || err.message || "Error adding student");
      });
  };

  return (
    <div style={container}>
      <h2 style={{ marginBottom: "20px" }}>Add Student</h2>

      <div style={grid}>

        {/* Admission No */}
        <div>
          <label style={label}>Admission No</label>
          <input
            value={form.AdmNo}
            style={{ ...input, background: "#f1f5f9" }}
            readOnly
          />
        </div>

        {/* Student Name */}
        <div>
          <label style={label}>Student Name</label>
          <input
            value={form.Name}
            onChange={(e) => handleChange("Name", e.target.value)}
            style={input}
          />
        </div>

        {/* Father Name */}
        <div>
          <label style={label}>Father Name</label>
          <input
            value={form.FatherName}
            onChange={(e) => handleChange("FatherName", e.target.value)}
            style={input}
          />
        </div>

        {/* Mother Name */}
        <div>
          <label style={label}>Mother Name</label>
          <input
            value={form.MotherName || ""}
            onChange={(e) => handleChange("MotherName", e.target.value)}
            style={input}
          />
        </div>

        {/* Address */}
        <div>
          <label style={label}>Address</label>
          <input
            value={form.Address || ""}
            onChange={(e) => handleChange("Address", e.target.value)}
            style={input}
          />
        </div>


        {/* Class */}
        <div>
          <label style={label}>Class</label>
          <select
            value={form.Class}
            onChange={(e) => handleChange("Class", e.target.value)}
            style={input}
          >
            <option>Nursery</option>
            <option>LKG</option>
            <option>UKG</option>
            <option>One</option>
            <option>Two</option>
            <option>Three</option>
            <option>Four</option>
            <option>Five</option>
            <option>Six</option>
            <option>Seven</option>
            <option>Eight</option>
            <option>Nine</option>
            <option>Ten</option>
          </select>
        </div>

        {/* Section */}
        <div>
          <label style={label}>Section</label>
          <select
            value={form.Section}
            onChange={(e) => handleChange("Section", e.target.value)}
            style={input}
          >
            <option>A</option>
            <option>B</option>
            <option>C</option>
            <option>D</option>
          </select>
        </div>

        {/* Admission Type */}
        <div>
          <label style={label}>Admission Type</label>
          <select
            value={form.AdmissionType}
            onChange={(e) => handleChange("AdmissionType", e.target.value)}
            style={input}
          >
            <option value="Old">Old Admission</option>
            <option value="New">New Admission</option>
          </select>
        </div>

        {/* Phone */}
        <div>
          <label style={label}>Phone</label>
          <input
            value={form.Phone}
            onChange={(e) => handleChange("Phone", e.target.value)}
            style={input}
          />
        </div>

        {/* Route */}
        <div style={{ gridColumn: "span 2" }}>
          <label style={label}>Conveyance Route</label>
          <select
            value={form.RouteNo}
            onChange={(e) => handleChange("RouteNo", Number(e.target.value))}
            style={input}
          >
            {routes.map(r => (
              <option key={r.routeno} value={r.routeno}>
                {r.routeno} - {r.routename} (₹{r.routefare})
              </option>
            ))}
          </select>
        </div>

      </div>

      <button onClick={handleSave} style={button}>
        Save Student
      </button>
    </div>
  );
}

// 🎨 STYLES
const container = {
  padding: "30px",
  maxWidth: "750px",
  margin: "30px auto",
  background: "#ffffff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.08)"
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  columnGap: "40px",
  rowGap: "18px"
};

const label = {
  display: "block",
  marginBottom: "5px",
  fontSize: "13px",
  color: "#555"
};

const input = {
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  width: "100%"
};

const button = {
  marginTop: "25px",
  padding: "12px 25px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

export default AddStudent;